<template>
  <div>
    <Navigation />
    <div class="grid__section">
    <section class="section__container top__container blog__details">
    
      <h1 class="title center__text">
        ENVOI SMS BEAUTÉ / SOINS / COIFFURE
      </h1>
          <img class="card__image" src="/../images/porter.png" alt="" />
      <h2>
        Les campagnes SMS sont un outil efficace pour les magasins de prêt-à-porter
      </h2>
      <p>
        Les magasins de prêt-à-porter sont en pleine transformation numérique, utilisant des canaux de 
        communication tels que les réseaux sociaux et l'email pour promouvoir leurs offres et augmenter 
        leur chiffre d'affaires. Les campagnes SMS sont largement utilisées par ces magasins, offrant 
        des avantages uniques en termes de rapidité et d'efficacité. Les SMS marketing permettent une 
        diffusion rapide et massive des offres, ce qui en fait un outil précieux pour ces commerces.
      </p>
      
      <h2>Dans le domaine du prêt-à-porter, l'envoi de SMS peut être utile dans diverses situations.</h2>
        <li>Ventes privées <br /></li>
        <li>Soldes<br /></li>
        <li>Nouvelles collections<br /></li>
        <li>Programme de fidélité<br /></li>
        <li>Ouverture exceptionnelle</li>
      <p>L'envoi de SMS vous permet de communiquer efficacement avec votre clientèle, de promouvoir vos offres
         spéciales et de renforcer la fidélité de vos clients. C'est un moyen rapide et direct pour informer vos
         clients des dernières nouveautés, des promotions en cours et des événements spéciaux dans votre boutique de prêt-à-porter.</p>
      <h2>Quelques exemples de SMS :</h2>
      <div class="cards">
        <div class="card">
          <img class="card__image" src="/../images/pret-porter-1.png" />
        </div>
        <div class="card">
          <img class="card__image" src="/../images/pret-porter-2.png" />
        </div>
        <div class="card">
          <img class="card__image" src="/../images/pret-porter-3.png" />
        </div>
      </div>
    
    </section>
    <SideNav/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
import SideNav from "./SideNav"
export default {
  components: {
    Navigation,
    Footer,
    SideNav
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";
</style>
